module.exports = __webpack_public_path__ + "img/icon-list-document.7aca314e.svg";